import { stringify } from "yaml";
import { cloneDeep, cloneDeepWith, max } from "lodash";;

const clean = (arg: any) => {
  if (arg && typeof arg == "object" && arg.__v_isRef) {
    const refObject = { ...arg, value: cloneDeep(arg.value) };
    delete refObject._value;
    delete refObject._rawValue;
    return refObject;
  }
  return cloneDeep(arg);
};
const cleanYaml = (arg: any) => {
  let cleaned = clean(arg);
  const removed = JSON.parse(JSON.stringify(cleaned));
  return stringify(removed);
};

console.dump = (...args: any[]) => {
  // TODO: なんとかcallerをバイパスして、ログの実態でこの行にインスペクトされることが無いようにしたい
  console.log(...args.map(clean));
};

console.dumpTrace = (...args: any[]) => {
  // TODO: なんとかcallerをバイパスして、ログの実態でこの行にインスペクトされることが無いようにしたい
  console.trace(...args.map(clean));
};

console.yaml = (...args: any[]) => {
  try {
    const values = args.map(cleanYaml).map((v) => v.trim());
    const maxLineLength = max(values.map((v) => v.split("\n").length)) ?? 0;
    // TODO: なんとかcallerをバイパスして、ログの実態でこの行にインスペクトされることが無いようにしたい
    console.log(values.join(maxLineLength > 1 ? "\n\n" : "\n"));
  } catch (e) {
    console.error(e);
    console.dump(...args);
  }
};

console.yamlTrace = (...args: any[]) => {
  try {
    const values = args.map(cleanYaml).map((v) => v.trim());
    const maxLineLength = max(values.map((v) => v.split("\n").length)) ?? 0;
    // TODO: なんとかcallerをバイパスして、ログの実態でこの行にインスペクトされることが無いようにしたい
    console.trace(values.join(maxLineLength > 1 ? "\n\n" : "\n"));
  } catch (e) {
    console.error(e);
    console.dump(...args);
  }
};
